export const logWarn = (message) => {
  console.warn(JSON.stringify(message, null, 4));
};
